import {allowDotsParse, allowDotsSerialize, camelKeys, clearEmpty, hasValue, lowerKeys, lowerArray, lowerCaseObjectArray} from '@/utils/obj'
import queryString from 'query-string'
import {addTimeZone, pad, toBoolean, convertOrganizationLevels} from '@/utils/converter';
import { parseFilterFromUrl } from '@/api/monitoring';
import {httpCache, urlConcat} from '@/utils/http';
import { DEBUG } from '@/config';
import { routerReplace } from '@/utils/router';

function toArray(v) {
  if (!hasValue(v)) return v;
  if (Array.isArray(v)) return v;

  return [v];
}

function dateFormat(date) {
  if (!(date instanceof Date)) {
    return null;
  }

  const d = pad(date.getDate()),
    m = pad(date.getMonth() + 1),
    y = pad(date.getFullYear(), 4);

  return `${y}-${m}-${d}`;
}

function treeToString (vl) {
  if (!vl || vl.length <= 0) return null;
  let str = vl.map(a => `${a.key}|${a.parents && a.parents.join(';') || ''}`).join(',');
  return str;
}

function getLocalDate (dateStr) {
  if (!dateStr || dateStr == '') {
    return null;
  }

  let dt = addTimeZone(dateStr);

  return new Date(dt);
}

function prsDt(v) {
  if (!v) return v;
  let ary = v.split(' ');
  if (ary && ary.length > 0) {
    let t = ary[0];
    return getLocalDate(t);
  }
}

function getWordsArray (keywordsParam, keywordsListParam) {
  let keywordsList = [];

  if (keywordsParam) {
    if (Array.isArray(keywordsParam))
      keywordsList = keywordsList.concat(keywordsParam);
    else
      keywordsList = keywordsList.concat(keywordsParam.split(','));
  }

  if (keywordsListParam)
    keywordsList = keywordsList.concat(keywordsListParam);

  return keywordsList;
}

function stringTreeParce (vl) {
  if (!vl) return;
  let itms = vl.split(',').map(a => {
    let keyParents = a.split('|');
    let key = keyParents && keyParents.length > 0 && keyParents[0];
    let parents = keyParents && keyParents.length > 1 && keyParents[1] && keyParents[1].split(';') || null;

    return {key, parents};
  });

  return itms;
}

const organizationLevels = [
  { id: '2', name: 'Fz223', title: '223 ФЗ', fullTitleAblative: '223 Федеральным Законом' },
  { id: '3', name: 'Commercial', title: 'коммерческие' },
  { id: '4', name: 'Fz44', title: '44 ФЗ', fullTitleAblative: '44 Федеральным Законом' },
  { id: '5', name: 'Pprf615', title: '615 ПП', fullTitleAblative: '615 Постановлением Правительства' }
];

const dictOrganizationLevels = organizationLevels.reduce((r, a) => { r[a.id] = a; return r; },{});

export function getOrganizationLevelById(id) {
  if (id == null) return null;
  if (typeof id !== 'string') id = id.toString();

  return dictOrganizationLevels[id];
}

export function getOrganizationLevels() {
  return organizationLevels;
}

export function organizationLevelsIdToCode(levelId) {
  return organizationLevels.find(i => i.id === levelId) || levelId;
}

export function getOrganizationLevel(level) {
  return organizationLevels.find(i=>i.name.toUpperCase() === level.toUpperCase()) || level;
}

const salesChannels = [
  { id: 1, name: 'tenders-search', title: 'Тендеры' },
  { id: 2, name: 'plans', title: 'Плановые закупки' },
  { id: 3, name: 'subcontracts', title: 'Субподряды и субпоставки' }
];

export function getSalesChannels() {
  return salesChannels;
}

import {OPEN_MONITORING_SEARCH_URL_PATH_ENDING} from '@/config'
export async function getFilterFromUrl(searchPage) {
  if (!searchPage) searchPage = OPEN_MONITORING_SEARCH_URL_PATH_ENDING;

  try {
    let urlSearch = window.location.search;
    if (urlSearch) {
      let urlPrepare = queryString.parseUrl(urlSearch);
      if (urlPrepare) {
        let query = urlPrepare.query;
        if (query) {
          let queryObject = allowDotsParse(urlPrepare.query);
          queryObject = lowerKeys(queryObject);

          if (queryObject) {
            let searchText = queryObject.query;

            let searchForm = queryObject.searchform || {};

            let showMore = searchText === '' && searchForm.organizationlevels === '';

            let organizationLevels = null;
            let isSmallAndAverageBusiness = null;

            if (searchForm || searchText || organizationLevels || isSmallAndAverageBusiness) {
              if (!searchForm) searchForm = {};

              isSmallAndAverageBusiness = searchForm.issmallandaveragebusiness && searchForm.issmallandaveragebusiness === 'true';

              if (searchForm.organizationlevels) {
                if (!Array.isArray(searchForm.organizationlevels)) {
                  organizationLevels = searchForm.organizationlevels !== 'Small' ? [searchForm.organizationlevels] : null;
                  isSmallAndAverageBusiness = searchForm.organizationlevels === 'Small' || isSmallAndAverageBusiness;

                } else if (searchForm.OrganizationLevels.length) {
                  organizationLevels = searchForm.organizationlevels;
                }
              }

              if (organizationLevels) {
                organizationLevels = organizationLevels.map(a => {
                  if (a == '2') return 'Fz223';
                  if (a == '4') return 'Fz44';
                  if (a == '5') return 'Pprf615';
                  if (a == '3') return 'Commercial';

                  return a;
                });
              }

              console.log(searchForm);
              console.log(organizationLevels);

              let salesChannel = null;
              if (searchForm.saleschannel && !Array.isArray(searchForm.saleschannel)) {
                salesChannel = [searchForm.saleschannel];
              }
              else {
                salesChannel = searchForm.saleschannel;
              }

              let keywordsList = getWordsArray(searchForm.keywords, searchForm.keywordslist);
              if (searchText && !keywordsList) keywordsList = [searchText];
              if (searchText && keywordsList) keywordsList.push(searchText);
              let excludeKeywordsList = getWordsArray(searchForm.excludekeywords, searchForm.excludekeywordslist);

              let documentSearchEnabled = toBoolean(searchForm.documentsearchenabled);
              if (documentSearchEnabled === null) documentSearchEnabled = true;

              let universalRegion = stringTreeParce(searchForm.universalregion || searchForm.deliveryregion || searchForm.region || null)

              if (universalRegion) universalRegion = universalRegion.map(a => {
                if (a.key.length <= 2)
                  return {key: JSON.stringify({key: a.key, level: 1})};

                if (a.parents && a.parents.some(aa => aa.length > 2))
                  return {key: JSON.stringify({key: a.key, level: 3})};

                return {key: JSON.stringify({key: a.key, level: 2})};
              });

              let organizationsTags = [];

              try {
                if (searchForm.organizationstags) {
                  organizationsTags = JSON.parse(searchForm.organizationstags);
                }
              } catch (e) {
                console.log(e);
                /*ignore*/
              }

              try {
                if (searchForm.customerinn) {
                  searchForm.customerinn
                            .split(',')
                            .map(innKpp => innKpp.match(/^([0-9]+)((_|\|)([0-9]*))?$/))
                            .forEach(m => {
                              if (m) {
                                organizationsTags.push({ inn: m[1], kpp: m[4] });
                              }
                            });
                }
              } catch (e) {
                console.log(e);
                /*ignore*/
              }

              let okpd2 = (searchForm.okpd2) ? searchForm.okpd2.toUpperCase() : null;

              let filter = {};
              filter.applicationEndDateFrom = prsDt(searchForm.applicationenddatefrom);
              filter.applicationEndDateTo = prsDt(searchForm.applicationenddateto);
              filter.combinedTradeRegistrationNumber = searchForm.traderegistrationnumber || searchForm.tradenumber || searchForm.tenderid;
              filter.currencyCode = searchForm.currencycode; // "-" поумолчанию
              filter.datePublishedFrom = prsDt(searchForm.datepublishedfrom);
              filter.datePublishedTo = prsDt(searchForm.datepublishedto);
              filter.universalRegion = universalRegion;
              filter.documentSearchEnabled = documentSearchEnabled;
              filter.excludeKeywords = excludeKeywordsList;
              filter.hasApplications = toBoolean(searchForm.hasapplications);
              filter.hasPrepayment = toBoolean(searchForm.hasprepayment);
              filter.isAvailableApplicationsWithoutSignature = searchForm.isavailableapplicationswithoutsignature;
              filter.isSmallAndAverageBusiness = toBoolean(isSmallAndAverageBusiness);
              filter.keywords = keywordsList;
              filter.marketPlaceIds = searchForm.marketplaceids;
              filter.maxApplicationGuarantee = searchForm.maxapplicationguarantee;
              filter.maxContractGuarantee = searchForm.maxcontractguarantee;
              filter.maxPrice = searchForm.maxprice;
              filter.minApplicationGuarantee = searchForm.minapplicationguarantee;
              filter.minContractGuarantee = searchForm.mincontractguarantee;
              filter.minPrice = searchForm.minprice;
              filter.name = queryObject.filtername || 'Мониторинг';
              filter.okpd2 = stringTreeParce(okpd2);
              filter.openAdditionalParams = showMore;
              filter.organizationLevels = organizationLevels && organizationLevels.filter(a => a);
              filter.organizationsTags = organizationsTags;
              filter.organizer = searchForm.organizername && [searchForm.organizername]; //!!!!
              filter.period = searchForm.period || 4; //4 - все, 2 - за день, 3 - за неделю
              filter.purchaseMethods = toArray(searchForm.purchasemethods);
              filter.saveToHistory = false;
              filter.salesChannel = salesChannel;
              filter.sectionIds = toArray(searchForm.sectionids);
              filter.state = searchForm.state;

              let kwrds = filter.keywords;
              if (kwrds) filter.keywords = kwrds.map(a => a.replace(/["']/g, '').replace(/ ~\d*/g, '').trim());

              let f = await parseFilterFromUrlPath(filter, searchPage);
              return f;
            }
          }
        }
      }
    }

    let f = await parseFilterFromUrlPath({}, searchPage);
    return f;

  } catch (e) {
    console.log(e);
    /*ignore*/
  }
}

export function mapFilterToFilterUrl(value, query)
{
  if (!value) return;

  if (!query) query = {};

  let tradeRegistrationNumber = value.combinedTradeRegistrationNumber && value.combinedTradeRegistrationNumber.length === 19 ? value.combinedTradeRegistrationNumber : '';
  let tradeNumber = value.combinedTradeRegistrationNumber && value.combinedTradeRegistrationNumber.length < 19 ? value.combinedTradeRegistrationNumber : '';
  let universalRegion = value && value.universalRegion && (value.universalRegion.map(aa => aa.key.indexOf('{') >= 0 ? ({...aa, key: JSON.parse(aa.key).key, parent: aa.parent && JSON.parse(aa.parent).key || null, parents: aa.parents && aa.parents.map(parent => JSON.parse(parent).key) || null}) : aa)) || null;

  let a = value;

  const keywordsIsArray = Array.isArray(a.keywords) && a.keywords.length > 1;

  lowerArray(a.keywords);
  lowerArray(a.excludeKeywords);
  lowerCaseObjectArray(a.organizationsTags)

  let searchForm = {
    state: a.state,
    keywords: !keywordsIsArray && a.keywords || null,
    keywordslist: keywordsIsArray && a.keywords || null,
    applicationenddatefrom: dateFormat(a.applicationEndDateFrom),
    applicationenddateto: dateFormat(a.applicationEndDateTo),
    currencycode: a.currencyCode,
    customerinn: null,
    datepublishedfrom: dateFormat(a.datePublishedFrom),
    datepublishedto: dateFormat(a.datePublishedTo),
    deliveryregion: null,
    documentsearchenabled: a.documentSearchEnabled,
    excludekeywords: a.excludeKeywords,
    hasapplications: a.hasApplications,
    hasprepayment: a.hasPrepayment,
    isavailableapplicationswithoutsignature: a.isAvailableApplicationsWithoutSignature,
    issmallandaveragebusiness: a.isSmallAndAverageBusiness,
    marketplaceids: a.marketPlaceIds,
    maxapplicationguarantee: a.maxApplicationGuarantee,
    maxcontractguarantee: a.maxContractGuarantee,
    maxprice: a.maxPrice,
    minapplicationguarantee: a.minApplicationGuarantee,
    mincontractguarantee: a.minContractGuarantee,
    minprice: a.minPrice,
    okpd2: treeToString(a.okpd2),
    organizationlevels: a.organizationLevels,
    organizationstags: a.organizationsTags && JSON.stringify(a.organizationsTags),
    OrganizerInn: null,
    period: a.period,
    purchasemethods: a.purchaseMethods,
    region: treeToString(universalRegion),
    sectionids: a.sectionIds,
    tenderid: null,
    tradenumber: tradeNumber,
    traderegistrationnumber: tradeRegistrationNumber,
    universalregion: null,
    saleschannel: a.salesChannel
  };

  // searchForm = clearEmpty(searchForm);

  let cleanForm = {};

  for (let key in searchForm) {
    if (searchForm[key]) {
      cleanForm[key] = searchForm[key];
    }
  }

  let urlParam = allowDotsSerialize({ searchform: cleanForm});
  let newQuery = {...query, ...urlParam};

  return newQuery;
}

function isFilterEmpty(filterInput, deleteMspAndPrepayment) {
  let filter = {};
  Object.assign(filter, filterInput)
  delete (filter.header);
  delete (filter.pageDescription);
  delete (filter.pageTitle);
  delete (filter.saveToHistory);
  delete (filter.total);
  delete (filter.period);
  delete (filter.sortKey);
  delete (filter.breadCrumbs);
  delete (filter.name);
  delete (filter.openAdditionalParams);

  if(deleteMspAndPrepayment === true) {
    filter.isSmallAndAverageBusiness = null;
    filter.hasPrepayment = null;
  }

  let filterEmpty = true;
  //Удаляем дефолтовые свойство.
  if(filter.state === 0 || filter.state === 1 || filter.state === 2) {
    delete (filter.state);
  }
  if(filter.documentSearchEnabled === true) {
    delete (filter.documentSearchEnabled);
  }

  for(let key in filter) {
    if (filter[key] != null && (!Array.isArray(filter[key]) || (Array.isArray(filter[key]) && filter[key].length > 0))) {
      filterEmpty = false;
      break;
    }
  }

  return filterEmpty;
}

export function getCanonicalPath(searchFilter, paging, dicts, regionsFlat, searchPath, defaultSearchPage)
{
  let seoFilter = getSeoSearchUrlRoute(searchFilter, paging, dicts, regionsFlat, searchPath, defaultSearchPage);

  return seoFilter.canonicalPath;
}

export function getSeoSearchUrlRoute(searchFilter, paging, dicts, regionsFlat, searchPath, defaultSearchPage) {
  let routePart = '';
  let filter = {};
  Object.assign(filter, searchFilter);

  let purchaseMethods =
  [
    {
      Abbreviation: "auction",
      PurchaseMethods : [4, 6, 27]
    },
    {
      Abbreviation: "price-request",
      PurchaseMethods: [3, 9, 10, 15, 26, 23, 22]
    },
    {
      Abbreviation: "proposal-request",
      PurchaseMethods: [ 1, 5, 8, 17, 14]
    },
    {
      Abbreviation: "tender-purchase",
      PurchaseMethods: [ 2, 7, 16, 24, 18, 21]
    }
  ];

  let isOnlyTendersSelected = false;

   if (filter.salesChannel && filter.salesChannel.length === 1) {
      const salesChannel = salesChannels.find(function(element){
        if (element.id === Number(filter.salesChannel[0]))
        {
          return element;
        }
      });

    let hasPurchaseMethods = false;

    if (salesChannel) {
      isOnlyTendersSelected = filter.salesChannel[0] == salesChannels[0].id;

      if(isOnlyTendersSelected && filter.purchaseMethods) {
        for (let i = 0; i < purchaseMethods.length; i++)
        {
          if(purchaseMethods[i].PurchaseMethods.sort().toString() === filter.purchaseMethods.sort().toString())
          {
            routePart = routePart + '/' + purchaseMethods[i].Abbreviation;
            hasPurchaseMethods = true;
            filter.purchaseMethods = null;
            isOnlyTendersSelected = false;
            break;
          }
        }
        /*
    if(!hasPurchaseMethods) {
      routePart = routePart + defaultSearchPage;
    }
        */
      }

      if(!hasPurchaseMethods) {
        //Только тендеры и сортировка по релевантности.
        if (isOnlyTendersSelected && paging && paging.sort && paging.sort.key === 1) {
          routePart = routePart + '/purchases';
        } else {
          routePart = routePart + '/' + salesChannel.name;
        }
      }

      filter.salesChannel = null;
    }
  }
  else {
    routePart = routePart + defaultSearchPage;
  }

  //let newQuery = mapFilterToFilterUrl(searchFilter, query);
  if (filter.keywords && filter.keywords.length == 1 && (filter.keywords.some(a => a.indexOf('"') < 0 && filter.keywords.some(a => a.indexOf("'") < 0)))) {
    routePart = routePart + '/' + cyrillToLatin(filter.keywords.join('_'), '-');

    filter.keywords = null;
    isOnlyTendersSelected = false;
  }

  if (filter.sectionIds && filter.sectionIds.length === 1) {
    let marketPlaceName = dicts.sections[filter.sectionIds[0]].name;
    routePart = routePart + '/' + cyrillToLatin(marketPlaceName, '-');
    filter.sectionIds = null;
    isOnlyTendersSelected = false;
  }

  if (filter.organizationLevels && filter.organizationLevels.length == 1) {
    routePart = routePart + '/' + convertOrganizationLevels(filter.organizationLevels).join('_');
    filter.organizationLevels = null;
    isOnlyTendersSelected = false;
  }

  /*
  if (filter.deliveryRegion && filter.deliveryRegion.length === 1) {
    routePart = routePart + '/' + cyrillToLatin(regionsFlat[filter.deliveryRegion[0].key].name, '_');
    filter.deliveryRegion = null;
  }
  */

  if (filter.universalRegion && filter.universalRegion.length === 1) {

    let region = regionsFlat[filter.universalRegion[0].key];
    if(region) {
      routePart = routePart + '/' + cyrillToLatin(regionsFlat[filter.universalRegion[0].key].name, '-');
      filter.universalRegion = null;
      isOnlyTendersSelected = false;
    }
  }

  if (filter.organizationsTags && filter.organizationsTags.length === 1) {
    routePart = routePart + '/' + cyrillToLatin(filter.organizationsTags[0].name, '-', true);
    filter.organizationsTags = null;
    isOnlyTendersSelected = false;
  }

  if (filter.okpd2 && filter.okpd2.length === 1 && filter.okpd2[0].key && filter.okpd2[0].key.match(/[\d.]+/)) {
    routePart = routePart + '/' + filter.okpd2[0].key.replace(' ', '_');
    filter.okpd2 = null;
    isOnlyTendersSelected = false;
  }

  let filterEmpty = isFilterEmpty(filter, true);

  if (filterEmpty && isOnlyTendersSelected && filter.isSmallAndAverageBusiness) {
    routePart = routePart + '/msp';
    filter.isSmallAndAverageBusiness = null;
    isOnlyTendersSelected = false;
  }

  if (filterEmpty && isOnlyTendersSelected && filter.hasPrepayment) {
    routePart = routePart + '/prepayment';
    filter.hasPrepayment = null;
    isOnlyTendersSelected = false;
  }

  filterEmpty = isFilterEmpty(filter);

  routePart = routePart.toLowerCase();
 
  if (DEBUG){
    routePart = routePart.replace(defaultSearchPage.toLowerCase(), defaultSearchPage);
  }

  return filterEmpty
    ? { path: urlConcat(searchPath, routePart), canonicalPath: urlConcat(searchPath, routePart) }
    : { path: urlConcat(searchPath, defaultSearchPage), canonicalPath: urlConcat(searchPath, routePart), filter: searchFilter }
}

async function parseFilterFromUrlPath(filter, searchPage) {
  if (typeof searchPage === "string") searchPage = {[searchPage.toLowerCase().replace('/', '')]: true};
  else if (searchPage) searchPage = searchPage.map(a => a.toLowerCase()).reduce((r, a) => {r[a] = true; return r;}, {});

  let path = window.location.pathname.toLowerCase();

  let pathArray = path.split('/').filter(a => a);
  let pathParams = [];
  let any = false;
  for (let pathArrayItem of pathArray) {
    if (!any) {
      if (searchPage[pathArrayItem.toLowerCase()]) {
        any = true;
      }
    } else {
      pathParams.push(pathArrayItem);
    }
  }

  if (!any) {
    pathParams = pathArray;
  }

  path = '/' + pathParams.join('/');
  path = decodeURI(path);

  let parseData = null;

  // хак для заголовка при переходе с главной
  if ((path && path.length > 0 && path !== '/' && path != ' ') || !filter.keywords || filter.keywords.length === 0) {
    parseData = await parseFilterFromUrl(path);
  }
  else {
    parseData = await parseFilterFromUrl(filter.keywords.join('_'));
  }

  if (parseData) {
    filter.header = parseData.Header;
    filter.pageTitle = parseData.PageTitle;
    filter.pageDescription = parseData.PageDescription;
    filter.breadCrumbs = parseData.BreadCrumbs;

    if (parseData.Filter) {
      if (!filter.purchaseMethods && parseData.Filter.PurchaseMethods) {
        filter.purchaseMethods = parseData.Filter.PurchaseMethods;
      }

      if (!filter.salesChannel && parseData.Filter.SalesChannel) {
        filter.salesChannel = parseData.Filter.SalesChannel;
      }

      if (!filter.sectionIds && parseData.Filter.SectionIds) {
        filter.sectionIds = parseData.Filter.SectionIds;
      }

      if (!filter.organizationLevels && parseData.Filter.OrganizationLevels) {
        filter.organizationLevels = parseData.Filter.OrganizationLevels;
      }

      if (!filter.deliveryRegion && parseData.Filter.DeliveryRegions) {
        filter.deliveryRegion = parseData.Filter.DeliveryRegions
          .map(i => {
            return {key: i.Key}
          });
      }

      if (!filter.universalRegion) {
        if (parseData.Filter.UniversalRegions) {
          filter.universalRegion = parseData.Filter.UniversalRegions
            .map(i => {
              let level = i.Level;
              let key = i.Key;

              if (!level) {
                if (key && key.length <= 2) level = 1;
                else level = 2;
              }

              return {key: JSON.stringify({key, level})};
            });
        }

        if (parseData.Filter.DeliveryCities) {
          if (!filter.universalRegion) filter.universalRegion = [];

          parseData.Filter.DeliveryCities
            .map(i => ({key: JSON.stringify({key: i.Key, level: i.Level || 3})}))
            .forEach(a => filter.universalRegion.push(a));
        }
      }

      if(parseData.Filter.Sort) {
        filter.sortKey = parseData.Filter.Sort;
      }

      if (!filter.okpd2 && parseData.Filter.Okpd2) {
        filter.okpd2 = parseData.Filter.Okpd2
          .map(i => {
            return {key: i.Key}
          });
      }

      if (!filter.isSmallAndAverageBusiness && parseData.Filter.IsSmallAndAverageBusiness) {
        filter.isSmallAndAverageBusiness = true;
      }

      if (!filter.hasPrepayment && parseData.Filter.HasPrepayment) {
        filter.hasPrepayment = true;
      }

      if (!filter.organizationsTags && parseData.Filter.OrganizationsTags) {
        filter.organizationsTags =
        parseData.Filter.OrganizationsTags
            .map(i => {
              return {id: i.Id, inn: i.Inn, innKpp: i.InnKpp, kpp: i.Kpp, name: i.Name};
            });
      }

      if ((!filter.keywords || !filter.keywords.length) && parseData.Filter.Keywords && parseData.Filter.Keywords != 'мониторинг') {
        filter.keywords = parseData.Filter.Keywords;
      }
    }
  }

  return filter;
}

export function setFilterToUrl(router, value, paging, dicts, regionsFlat, searchPath, defaultSearchPage) {
  let query = router.query || {};
  let seoFilter = getSeoSearchUrlRoute(value, paging, dicts, regionsFlat, searchPath, defaultSearchPage);

  if (!seoFilter.filter
    || (Object.keys(seoFilter.filter).length === 0
      && seoFilter.filter.constructor === Object)) {
    routerReplace(router, { path: seoFilter.path });
    return { newQuery: null, canonicalPath: "" };
  }
  else {
    let newQuery = mapFilterToFilterUrl(seoFilter.filter, query);

    routerReplace(router, { path: seoFilter.path, query: newQuery });

    if (!DEBUG){
      routerReplace(router, router.currentRoute.fullPath.toLowerCase());
    }

    return { newQuery: newQuery, canonicalPath: seoFilter.canonicalPath };
  }
}

const purchaseMethodIdToNameArray = [
  { id: '1', name: 'ProposalRequest', title: 'Запросы предложений' },
  { id: '2', name: 'TenderPurchase', title: 'Конкурсы' },
  { id: '3', name: 'PriceRequest', title: 'Запросы цен\\котировок' },
  { id: '4', name: 'Auction', title: 'Аукционы' }
];

export function getSeoPurchaseMethods() {
  return purchaseMethodIdToNameArray;
}

export function getPurchaseMethodById(purchaseMethodId) {
  return purchaseMethodIdToNameArray.find(i => i.id === purchaseMethodId);
}

export function getPurchaseMethodByName(purchaseMethodName) {
  return purchaseMethodIdToNameArray.find(i => i.name.toUpperCase() === purchaseMethodName.toUpperCase());
}

const arrru = ['Я', 'я', 'Ю', 'ю', 'Щ', 'щ', 'Ч', 'ч', 'Ш', 'ш', 'Ж', 'ж', 'А', 'а', 'Б', 'б', 'В', 'в', 'Г', 'г', 'Д', 'д', 'Э', 'э', 'Е', 'е', 'Ё', 'ё', 'З', 'з', 'И', 'и', 'Й', 'й', 'К', 'к', 'Л', 'л', 'М', 'м', 'Н', 'н', 'О', 'о', 'П', 'п', 'Р', 'р', 'С', 'с', 'Т', 'т', 'У', 'у', 'Ф', 'ф', 'Х', 'х', 'Ц', 'ц', 'Ы', 'ы', 'ь', 'Ь', 'ъ', 'Ъ', "[^A-Za-z0-9-' ]"];
const arren = ['Ya', 'ya', 'Yu', 'yu', 'Sch', 'sch', 'Ch', 'ch', 'Sh', 'sh', 'Zh', 'zh', 'A', 'a', 'B', 'b', 'V', 'v', 'G', 'g', 'D', 'd', 'E\'', 'e\'', 'E', 'e', 'Yo', 'yo', 'Z', 'z', 'I', 'i', 'J', 'j', 'K', 'k', 'L', 'l', 'M', 'm', 'N', 'n', 'O', 'o', 'P', 'p', 'R', 'r', 'S', 's', 'T', 't', 'U', 'u', 'F', 'f', 'H', 'h', 'C', 'c', 'Y', 'y', '\'', '\'', '\'\'', '\'\'', ''];

export function cyrillToLatin(text, spaceReplacement, replaceCommas) {
  for (let i = 0; i < arrru.length; i++) {
    let reg = new RegExp(arrru[i], "g");
    text = text.replace(reg, arren[i]);
  }

  /*
  if(text && replaceCommas === true){
    text = text.replace(/"/g, '');
  }
  */

  return spaceReplacement
    ? text.split(' ').join(spaceReplacement)
    : text;
}

function latinToCyrill(text) {
  for (let i = 0; i < arren.length; i++) {
    var reg = new RegExp(arren[i], "g");
    text = text.replace(reg, arrru[i]);
  }
  return text;
}

function getArray(str) {
  let r = [];

  if(Array.isArray(str)) r = str;
  else if(str && typeof str === "string" ) r  = str.split(',');

  return r;
}

export function mapFilterFromFilterApi(a) {
  a = camelKeys(a);

  let keywordsList = getWordsArray(a.keywords, a.keywordsList);
  let excludeKeywordsList = getWordsArray(a.excludeKeywords, a.excludeKeywordsList);

  let stringTreeParce = (vl) => {
    if (!vl) return;
    let itms = vl.split(',').map(a => {
      let keyParents = a.split('|');
      let key = keyParents && keyParents.length > 0 && keyParents[0];
      let parents = keyParents && keyParents.length > 1 && keyParents[1] && keyParents[1].split(';') || null;

      return {key, parents};
    });

    return itms;
  };

  let organizerInfo;
  if (a.organizerInn || a.organizerName) {
    organizerInfo = [{innKpp: a.organizerInn, name: a.organizerName}];
  }

  let customerInfo;
  if (a.customerInn || a.customerName) {
    customerInfo = [{innKpp: a.customerInn, name: a.customerName}];
  }

  let universalRegion = null;
  let deliveryRegion = null;

  let coreRegion = stringTreeParce(a.universalRegion || a.deliveryRegion || a.region || null);
  if (coreRegion) coreRegion = coreRegion.map(x => {
    if (x.key.length <= 2)
      return {key: JSON.stringify({key: x.key, level: 1})};

    if (x.parents && x.parents.some(aa => aa.length > 2))
    {
      let parents = [];
      let level = 3;
      x.parents.forEach(function(p){
        parents.push(JSON.stringify({key: p, level: --level}));
      });
      return {key: JSON.stringify({key: x.key, level: 3}), level: 3, parents: parents};
    }
    return {key: JSON.stringify({key: x.key, level: 2})};
  });

  if (a.salesChannels[0] === 3){
    deliveryRegion = coreRegion;
  }
  else {
    universalRegion = coreRegion;
    deliveryRegion = stringTreeParce(a.deliveryRegion);
  }

  let nextFilter = {
    id: a.id,
    name: a.name,
    total: a.total,
    keywords: keywordsList,
    excludeKeywords: excludeKeywordsList,
    datePublishedFrom: getLocalDate(a.datePublishedFrom),
    datePublishedTo: getLocalDate(a.datePublishedTo),
    minPrice: a.minPrice,
    maxPrice: a.maxPrice,
    minContractGuarantee: a.minContractGuarantee,
    maxContractGuarantee: a.maxContractGuarantee,
    minApplicationGuarantee: a.minApplicationGuarantee,
    maxApplicationGuarantee: a.maxApplicationGuarantee,
    documentSearchEnabled: a.documentSearchEnabled,
    organizer: a.organizerName && [a.organizerName], //!!!!
    organizationsTags: a.organizationsTags,
    organizationLevels: getArray(a.organizationLevels),//a.OrganizationLevels && a.OrganizationLevels, "Fz44,Fz223" +
    currencyCode: a.currencyCode || null, // "-" поумолчанию
    period: a.period || 4, //4 - все, 2 - за день, 3 - за неделю
    deliveryRegion: deliveryRegion,
    region: stringTreeParce(a.region),
    universalRegion: universalRegion,
    state: a.state,
    hasPrepayment: a.hasPrepayment,
    hasApplications: a.hasApplications,
    okpd2: stringTreeParce(a.okpd2),
    sectionIds: getArray(a.sectionIds),//+
    combinedTradeRegistrationNumber: null,
    color: { backgroundColor: a.colorNumber },
    marketPlaceIds: getArray(a.marketPlaceIds), //+
    purchaseMethods: getArray(a.purchaseMethods),//+
    applicationEndDateFrom: getLocalDate(a.applicationEndDateFrom),
    applicationEndDateTo: getLocalDate(a.applicationEndDateTo),
    isSmallAndAverageBusiness: a.isSmallAndAverageBusiness,
    isAvailableApplicationsWithoutSignature: a.isAvailableApplicationsWithoutSignature,
    maxOrdersCount: a.maxOrdersCount,
    publicationDatePeriod: a.publicationDatePeriod,
    organizerInfo,
    customerInfo
  };

  return nextFilter;
}

import {search, getCounters} from '@/api/order';
// первый запрос со страницы мониторинга, его занчения попадают в cache http запросов
// для ускорения работы страницы стоит вызвать его как можно раньше, пусть себе фигачит паралели пока гругится основная страница
export async function firstSearch({state, saveToHistory = false} = {}) {
  let filter = await getFilterFromUrl();
  if (filter && filter.documentSearchEnabled == null) filter.documentSearchEnabled = true;
  if (filter) {
    filter.state = state;
    filter.saveToHistory = saveToHistory;
  }

  const pageSettings = { page_size: 20, page_index: 1, sorting_field: "DatePublished", sorting_direction: "Desc" };
  let response = camelKeys(await search(filter, pageSettings));

  let items = response.isSuccess && response.result.tenders || [];
  let params = items.map((tndr) => {
    let salesChannel = tndr.salesChannel;
    let key = tndr.id;

    return {id: key, salesChannel};
  });

  let counters = await getCounters(params);

  return {
    filter,
    items,
    counters
  }
}
